var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cash-flow-transaction-type-select" },
    [
      _c(
        "a-select",
        {
          staticClass: "cash-flow-transaction-type-select__select",
          attrs: {
            mode: "multiple",
            size: "small",
            value: _vm.value,
            placeholder: _vm.placeholder
          },
          on: {
            change: function($event) {
              return _vm.$emit("change", $event)
            }
          }
        },
        _vm._l(_vm.transactionTypeOptions, function(type) {
          return _c(
            "a-select-option",
            {
              key: type.value,
              attrs: { value: type.value, label: type.label }
            },
            [_vm._v(" " + _vm._s(type.label) + " ")]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }